import { Chip, Grid } from '@material-ui/core';
import { DateRangeRounded, DescriptionRounded, DoneRounded, EmailRounded, HomeWorkRounded, PhoneRounded, RouterRounded, ScheduleRounded, WorkRounded } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { formatDate224 } from '@webapps/utils';
import { formatPhoneNumber } from 'react-phone-number-input';
const BusinessInfo = ({ opcoRecord, dataCompletion }) => {
  const { classes, css, cx, global } = useStyles(styles);

  return (
    <div className={cx(global.fcjs, css({ gap: 24 }))}>
      <div className={cx(global.title, global.blueBar)}>Entreprise</div>
      <Grid container spacing={1}>
        {opcoRecord?.businessEmployer ? (
          <Grid item xs={6} className={cx(global.fcjs, css({ gap: 4 }))}>
            <div className={cx(global.infoText, classes.overviewText)}>
              <HomeWorkRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Entreprise : </span>{opcoRecord?.businessEmployer?.business?.name}</div>
            </div>
            <div className={cx(global.infoText, classes.overviewText)}>
              <WorkRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Intitulé de job : </span>{opcoRecord?.affiliate?.job?.label}</div>
            </div>
            <div className={cx(global.infoText, classes.overviewText)}>
              <RouterRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>OPCO : </span>{opcoRecord?.opco || opcoRecord?.businessEmployer?.opco}</div>
            </div>
            <div className={cx(global.infoText, classes.overviewText)}>
              <DescriptionRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Type de contrat : </span>{opcoRecord?.affiliate?.contractType?.label}</div>
            </div>
            <div className={cx(global.infoText, classes.overviewText)}>
              <DateRangeRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Dates d'entrée : </span>{formatDate224(opcoRecord?.businessContract?.executionDate)}</div>
            </div> 
            <div className={cx(global.infoText, classes.overviewText)}>
              <EmailRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Adresse email : </span>{opcoRecord?.businessEmployer?.email || 'Non renseigné'}</div>
            </div>
            <div className={cx(global.infoText, classes.overviewText)}>
              <PhoneRounded className={global.infoIcon} style={{ color: "#0060F9" }} />
              <div><span style={{ fontWeight: 600 }}>Téléphone : </span>{opcoRecord?.businessEmployer?.phone ? formatPhoneNumber(opcoRecord?.businessEmployer?.phone) : 'Non renseigné'}</div>
            </div>
          </Grid>
          ) : (
          <Grid item xs={6} className={cx(global.fcjs, css({ gap: 4 }))}>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <HomeWorkRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Entreprise :</div>
            </div>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <WorkRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Intitulé de job :</div>
            </div>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <RouterRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>OPCO :</div>
            </div>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <DescriptionRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Type de contrat :</div>
            </div>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <DateRangeRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Dates d'entrée :</div>
            </div> 
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <EmailRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Adresse email :</div>
            </div>
            <div className={cx(global.infoText, classes.overviewTextDisabled)}>
              <PhoneRounded className={global.infoIcon} style={{ color: "#92ABD2" }} />
              <div>Téléphone :</div>
            </div>
          </Grid>
          )
        }
        <Grid item xs={6} className={cx(global.fcjs, css({ gap: 4 }))}>
          <Chip 
            className={cx(opcoRecord?.businessEmployer ? global.chipValid : global.chipDisabled, global.fracjs)} 
            label={opcoRecord?.businessEmployer ? (
              <div className={cx(global.frac, css({gap: 12}))}><DoneRounded style={{ fontSize: 20 }} /> <div>Inscrit sur Linkpick</div></div>
            ) : (
              <div className={cx(global.frac, css({gap: 12}))}><ScheduleRounded style={{ fontSize: 20 }} /> <div>Inscrit sur Linkpick</div></div>
            )
            } 
            size="medium" 
          />
          <Chip 
            className={cx(
              opcoRecord?.businessEmployer 
                ? dataCompletion 
                  ? global.chipPending 
                  : global.chipValid
                : global.chipDisabled, 
                global.fracjs
              )}  
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {opcoRecord?.businessEmployer && !dataCompletion ? (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Données complètes</div>
                </>
              ) : (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Complétion des données</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          />
          <Chip 
           className={cx(
            opcoRecord?.contract 
              ? opcoRecord?.contract?.businessSignAction !== "SIGNED" || opcoRecord?.contract?.status === "OUTDATED"
                ? global.chipPending 
                : global.chipValid 
              : global.chipDisabled, 
              global.fracjs
            )}            
            label={
            <div className={cx(global.frac, css({gap: 12}))}>
              {opcoRecord?.contract?.businessSignAction != "SIGNED" ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Signatures en attente</div>
                </>
              ) : opcoRecord?.contract?.status === "OUTDATED" ? (
                <>
                  <ScheduleRounded style={{ fontSize: 20 }} /> <div>Contrat et convention obsolètes</div>
                </>
              ) : (
                <>
                  <DoneRounded style={{ fontSize: 20 }} /> <div>Contrat et convention signés</div>
                </>
              )}
            </div>
            } 
            size="medium" 
          />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
 overviewText: {
  color: "#152652",
  display: 'flex',
  alignItems: 'center',
  maxWidth: '90%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
 },
 overviewTextDisabled: {
  color: "#92ABD2",
  display: 'flex',
  alignItems: 'center',
 }
});

export default BusinessInfo;